<script lang="ts" setup>
const isCN = !!import.meta.env.VITE_IS_CN;
import LogoIconCn from "./LogoIconCn.vue";
import LogoIconEn from "./LogoIconEn.vue";
</script>
<template>
  <component :is="isCN ? LogoIconCn : LogoIconEn" />
</template>
